import { render, staticRenderFns } from "./ItemConfiguration.vue?vue&type=template&id=4a115d92"
import script from "./ItemConfiguration.vue?vue&type=script&lang=js"
export * from "./ItemConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports